import React from "react";
import styles from "./errroPage.module.scss";
import AlertIcon from "static/images/alert.png";

export const ErrorPage = ({ title, description }) => {
	return (
		<div className={styles.errorBlock}>
			<div className={styles.block}>
				<img src={AlertIcon} alt="" className={styles.alertIcon} />
				<h1 className={styles.title}>{title}</h1>
				<p className={styles.description}>{description}</p>
				<p className={styles.contactSupport}>
					Still have a problem? Contact our support team
				</p>
			</div>
		</div>
	);
};
